{
  "name": "car-rental",
  "$schema": "../../node_modules/nx/schemas/project-schema.json",
  "projectType": "application",
  "prefix": "ngx",
  "sourceRoot": "apps/car-rental/src",
  "tags": [],
  "targets": {
    "build": {
      "executor": "@angular-devkit/build-angular:application",
      "outputs": ["{options.outputPath}"],
      "options": {
        "outputPath": "dist/apps/car-rental",
        "index": "apps/car-rental/src/index.html",
        "browser": "apps/car-rental/src/main.ts",
        "polyfills": ["zone.js"],
        "tsConfig": "apps/car-rental/tsconfig.app.json",
        "inlineStyleLanguage": "scss",
        "assets": [
          "apps/car-rental/src/favicon.ico",
          "apps/car-rental/src/assets",
          "apps/car-rental/src/assets/images",
          "apps/car-rental/src/favicon.png",
          "apps/car-rental/src/firebase-messaging-sw.js",
          {
            "glob": "**/*",
            "input": "apps/car-rental/public",
            "output": "/"
          },
          {
            "glob": "**/*",
            "input": "node_modules/leaflet/dist/images",
            "output": "/assets/img/markers"
          }
        ],
        "stylePreprocessorOptions": {
          "includePaths": ["node_modules", "libs/generic/@theme/src/lib/styles"]
        },
        "styles": ["libs/generic/@theme/src/lib/styles/styles.scss", "apps/car-rental/src/styles.scss"],
        "allowedCommonJsDependencies": [
          "angular2-chartjs",
          "echarts",
          "lodash",
          "ionicons",
          "leaflet",
          "rfdc",
          "buffer",
          "eva-icons",
          "moment",
          "tinymce",
          "ckeditor",
          "zrender/lib/svg/svg",
          "zrender/lib/vml/vml"
        ],
        "extractLicenses": false,
        "sourceMap": true,
        "optimization": false,
        "namedChunks": true,
        "serviceWorker": "apps/car-rental/ngsw-config.json"
      },
      "configurations": {
        "production": {
          "optimization": {
            "scripts": true,
            "styles": {
              "minify": true,
              "inlineCritical": false
            },
            "fonts": true
          },
          "outputHashing": "all",
          "sourceMap": false,
          "namedChunks": false,
          "extractLicenses": true,
          "fileReplacements": [
            {
              "replace": "apps/car-rental/src/environments/environment.ts",
              "with": "apps/car-rental/src/environments/environment.prod.ts"
            }
          ]
        },
        "devProduction": {
          "optimization": {
            "scripts": true,
            "styles": {
              "minify": true,
              "inlineCritical": false
            },
            "fonts": true
          },
          "outputHashing": "all",
          "sourceMap": true,
          "namedChunks": true,
          "extractLicenses": true,
          "fileReplacements": [
            {
              "replace": "apps/car-rental/src/environments/environment.ts",
              "with": "apps/car-rental/src/environments/environment.prod.ts"
            }
          ]
        },
        "prodWatch": {
          "optimization": true,
          "outputHashing": "all",
          "sourceMap": false,
          "namedChunks": false,
          "extractLicenses": true,
          "fileReplacements": [
            {
              "replace": "apps/car-rental/src/environments/environment.ts",
              "with": "apps/car-rental/src/environments/environment.prod.ts"
            }
          ],
          "watch": true
        },
        "development": {
          "optimization": false,
          "extractLicenses": false,
          "sourceMap": true
        }
      },
      "defaultConfiguration": "production"
    },
    "serve": {
      "executor": "@angular-devkit/build-angular:dev-server",
      "options": {
        "verbose": true,
        "port": 4202
      },
      "configurations": {
        "production": {
          "buildTarget": "car-rental:build:devProduction"
        },
        "development": {
          "buildTarget": "car-rental:build:development"
        }
      },
      "defaultConfiguration": "development"
    },
    "extract-i18n": {
      "executor": "@angular-devkit/build-angular:extract-i18n",
      "options": {
        "buildTarget": "car-rental:build"
      }
    },
    "lint": {
      "executor": "@nx/eslint:lint"
    },
    "test": {
      "executor": "@nx/jest:jest",
      "outputs": ["{workspaceRoot}/coverage/{projectRoot}"],
      "options": {
        "jestConfig": "apps/car-rental/jest.config.ts"
      }
    },
    "serve-static": {
      "executor": "@nx/web:file-server",
      "options": {
        "buildTarget": "car-rental:build",
        "staticFilePath": "dist/apps/car-rental/browser"
      }
    }
  }
}
